import React, { ReactElement, useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { formatNumber } from '../../../reducer/actions/formatNumber';
import { gridFilteredSortedRowEntriesSelector } from '@mui/x-data-grid-pro';
import { isRowExcludedFromSummary } from './summaryFilters';

// A priceWithCurrency oszlopok (pl. Original Cost, Final Cost) SUM sora.
// A látható (szűrt+rendezett) sorok értékeit pénznemenként (currency.name) összegzi.
export const PriceWithCurrencySummaryCell = ({
  props,
  apiRef,
  schema,
}: {
  props: any;
  apiRef: any;
  schema?: any;
}): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);
  const [totals, setTotals] = useState<Record<string, number>>({});

  const filteredSortedRowsAndIds = gridFilteredSortedRowEntriesSelector(apiRef);
  const visibleRows = filteredSortedRowsAndIds.map((row: any) => row?.model);

  useEffect(() => {
    const sums: Record<string, number> = {};
    const field = props.field;

    visibleRows.forEach((row: any) => {
      if (!row || row.id === 'SUM') return;
      if (isRowExcludedFromSummary(row, schema)) return;
      const cell = row[field];
      if (!cell || !cell.value) return;
      const currency = cell?.currency?.name || '-';
      sums[currency] = (sums[currency] || 0) + Number(cell.value || 0);
    });

    setTotals(sums);
  }, [visibleRows]);

  const entries = Object.entries(totals).filter(([, val]) => val);

  useEffect(() => {
    setTooltip(false);
    if (divRef.current) {
      const el: any = divRef.current;
      const parent = el.parentNode;
      if (parent && el.getBoundingClientRect().width > parent.getBoundingClientRect().width) {
        setTooltip(true);
      }
    }
  });

  const content = (
    <>
      {entries.map(([currency, val]) => (
        <p key={currency} style={{ margin: 0 }}>
          {formatNumber(val)} {currency}
        </p>
      ))}
    </>
  );

  return (
    <Box
      ref={divRef}
      className={`whitespace-nowrap ${tooltip ? 'has-tooltip' : 'doesnthave-tooltip'}`}
      sx={{ lineHeight: '10px' }}
    >
      {tooltip ? (
        <Tooltip
          disableInteractive
          title={entries.map(([c, v]) => `${formatNumber(v)} ${c}`).join(' / ')}
          slotProps={{ tooltip: { sx: { fontSize: '11px' } } }}
        >
          <span>{content}</span>
        </Tooltip>
      ) : (
        content
      )}
    </Box>
  );
};

export default PriceWithCurrencySummaryCell;
